exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-70a6f672","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/player/page/Youtube.vue
// module id = 82
// module chunks = 0